<template>
  <header
    v-if="string || data?.title"
    :class="$style.root"
  >
    <h1 :class="$style.heading">
      {{ string || data?.title }}
    </h1>
  </header>
</template>

<script lang="ts" setup>
const props = defineProps({
  data: {
    type: Object,
    required: false
  },
  string: {
    type: String,
    required: false
  }
})
</script>

<style module>
.root {
  composes: container from global;
  text-align: center;
  margin-bottom: calc(var(--font-default--line-height) + var(--padding--element--top) + var(--padding--element--bottom));
}

.heading {
  composes: reset-heading font-size-large from global;
}
</style>
